import { TickBullet } from '@cx-web/components/primitives/icons';
import Modal from '@cx-web/components/primitives/modal-component';
import { type MyOCData } from '@cx-web/domain-types/myoc';
import { useLayoutStore } from '@cx-web/ui-shell/layout-store-provider';
import { useNavigation } from '@cx-web/ui-shell/navigation-context';
import { trackEvent } from '@cx-web/utils/dataLayer';

import { LegacyAuthModalTrigger } from '~/components/composites/legacy-auth-modal';

import styles from './ArticleLoginWall.module.css';

export const ArticleLoginWall = ({ myocData, resourcesUrl }: { myocData: MyOCData; resourcesUrl: string }) => {
  const { currentPath } = useNavigation();
  const deviceType = useLayoutStore(s => s.deviceType);
  const isMobile = deviceType.toLowerCase() !== 'desktop';

  const background = (
    <picture className={styles.backgroundContainer}>
      <source
        srcSet={`${resourcesUrl}/assets/img/global/product-switcher-locked-background-${isMobile ? 'mobile.png' : 'desktop.png'}`}
      />
      <img
        alt="login-wall-background"
        data-testid="login-wall-background"
        src={`${resourcesUrl}/assets/img/global/product-switcher-locked-background-${isMobile ? 'mobile.png' : 'desktop.png'}`}
      />
    </picture>
  );

  const bulletPoints = [
    {
      title: 'Expert Picks and Daily Best Bets',
      body: "Exclusive picks from the industry's most profitable handicappers. Our best-in-class experts have you covered with picks on the NFL, NCAAF, MLB, NBA and more",
    },
    {
      title: 'Positive Value Bets',
      body: 'Game and Player prediction AI models for every matchup',
    },
    {
      title: 'Public Betting Splits',
      body: 'Real-time market data on where the public and sharp action is betting',
    },
  ];

  const renderPrimaryCta = (
    <button className={styles.primaryCta} type="button">
      Create account
    </button>
  );

  const renderSecondaryCta = (
    <button className={styles.secondaryCta} data-testid="cancel" type="button">
      log in
    </button>
  );

  return (
    <div className={styles.articleLoginWall}>
      {background}
      <div className={styles.contentWrapper}>
        <h1 className={styles.title}>Join the oddschecker Roster for Free</h1>
        <h4 className={styles.subtitle}>
          Log in or create a free account to score complete access to the best picks and intelligence in the industry
        </h4>

        <div className={styles.bulletsWrapper} data-testid="bullets-wrapper">
          {bulletPoints.map((item, i) => (
            <div className={styles.benefitBullet} data-testid="benefit-bullet" key={i}>
              <span className={styles.itemIcon} data-testid="icon">
                <TickBullet />
              </span>
              <div className={styles.itemTextWrapper}>
                <div className={styles.itemHeader} data-testid="info-header">
                  {item?.title}
                </div>
                <div className={styles.itemBody} data-testid="info-body">
                  {item?.body}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className={styles.ctaWrapper}>
          <Modal
            buttonComponent={renderPrimaryCta}
            onClickEvent={() => {
              trackEvent('wall_sign_up', {});
            }}
            returnButton
            transparent
          >
            <LegacyAuthModalTrigger currentPath={currentPath} myocData={myocData} viewToOpen="Signup" />
          </Modal>
          <Modal
            buttonComponent={renderSecondaryCta}
            onClickEvent={() => {
              trackEvent('wall_login', {});
            }}
            returnButton
            transparent
          >
            <LegacyAuthModalTrigger currentPath={currentPath} myocData={myocData} viewToOpen="Login" />
          </Modal>
        </div>
      </div>
    </div>
  );
};
